export default __webpack_public_path__ + "static/flowermarks-9a24796554b727dd5462f04f11daa8ed.png";